import IconMore from "./IconMore";

export default function CardSpeaker({item, onClick, className= '',isOpen = true, ...rest}) {
    const hasLinks = item.links && item.links.length > 0;

    return (
        <div className={`flex flex-row flex-1 rounded-[3rem] border-[0.25rem] border-[#C7C8D3] bg-[#0E2242] ${className}`} onClick={onClick}>
            <div className="flex-1 flex flex-col">
                <div className={`flex flex-col h-full
                font-extralight text-[5.75rem] px-[6.25rem] pt-[6.5625rem] pb-[5.125rem] leading-none
                ${!isOpen ? 'border-b-[0.25rem] border-[#C7C8D3]' : ''}
                relative
                `}>
                    <span className="text-[2.25rem] block mb-auto leading-[3.625rem]" dangerouslySetInnerHTML={{__html:item.info}}></span>
                    <span className="text-[4.5rem] block mb-[4rem] leading-[5.5rem]" dangerouslySetInnerHTML={{__html:item.summary}}></span>
                    {item.speakers && item.speakers.map((speaker, index) => (
                    <div className="flex items-center mb-[2rem] last:mb-0" key={index}>
                        <img src={`${process.env.PUBLIC_URL}/speakers/${speaker.photo}`} alt={speaker.name} className="w-[9.5rem] h-[9.5rem] rounded-full mr-[3.1875rem] border-[0.1875rem] border-[#D9D9D9] object-cover" />
                        <div className="flex flex-col">
                            <span className="text-[2.25rem] block leading-[3.25rem] font-bold">{speaker.name}</span>
                            <span className="text-[2.25rem] block leading-[3.25rem]">{speaker.position}</span>
                        </div>
                    </div>
                    ))}
                </div>
                {!isOpen && (
                <div className="flex pl-[6.25rem] py-[4.6875rem] text-[1.75rem] items-center">
                    More information <IconMore className="w-[1.5rem] h-[1.5rem] ml-[0.8rem]" />
                </div>
                )}
            </div>
            {isOpen && (
            <div className="flex-0 w-[89.3125rem] flex border-l-[0.25rem] border-[#e2e2e2]">
                <div className="pl-[10rem] pt-[6.75rem] pb-[5.625rem] px-[9.68755rem]
                min-h-[25.125rem]
                items-center
                text-[2.125rem] font-light leading-[3.5rem]
                space-y-[3.75rem]"
                dangerouslySetInnerHTML={{__html:item.content}}
                >
                </div>
            </div>
            )}
        </div>
    );
};